import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import { Button, TextField } from 'components';
import { FaEdit } from 'react-icons/fa';

const defaultStyle = {
    backgroundColor: 'var(--primary-color)',
    editBackgroundColor: 'var(--focus-color)',
}

const Container = styled.div`
    background-color: ${props => props.styles.backgroundColor};
    border-radius: 5px;
    box-shadow: ${props => props.edit && 'var(--box-shadow)'};
    padding: 0 0.5rem 0 0;
    margin: 0.5rem;
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 0.2rem;
    align-items: center;
    justify-items: center;
    max-width: 15rem;
    cursor: ${props => !props.edit ? 'pointer' : 'auto'};
    /* :hover {
        filter: brightness(var(--brightness));
    } */
`

const TitleInput = props => {
    const {
        value,
        styles,
        onSubmit
    } = props;
    const [edit, setEdit] = React.useState(false);
    const [title, setTitle] = React.useState(value)
    const updatedStyle = Object.assign({}, defaultStyle, styles);

    const iconStyle = {
        fontSize: '0.8rem',
        margin: 0,
        padding: '0.2rem',
        boxShadowColor: edit ? 'var(--box-shadow)' : 'transparent',
        backgroundColor: edit ? updatedStyle['editBackgroundColor'] : updatedStyle['backgroundColor']
    }

    const onSubmitHandler = () => {
        if(edit){
            setEdit(false)
            onSubmit(title)
        } else {
            setEdit(true)
        }
    }

    const onKeyDown = (event) => {
        if([13, 27].includes(event.keyCode)){
            event.preventDefault()
            if(title.length > 0){
                onSubmitHandler()
                setEdit(false)
            } else {
                setEdit(false)
                setTitle(value)
            }
        }
    }

    return (
        <Container styles={updatedStyle} >
            <TextField type='single'  value={title} submitOnBlur
                onKeyDown={onKeyDown} onKeyPress={onKeyDown} size={30}
                style={{textAlign:'end', textOverflow: 'ellipsis', fontSize: '0.9rem', fontWeight: 'bold', cursor: !edit && 'pointer'}}
                onChange={(event) => setTitle(event.target.value)} 
                onBlur={onSubmitHandler} onClick={() => setEdit(true)} edit={edit}
                onFocus={() => setEdit(true)}/>
            <Button icon={<FaEdit style={iconStyle}/>} styles={iconStyle} onSelect={onSubmitHandler}/>
        </Container>
    )
}

export default TitleInput;